import React, { useState, useEffect } from 'react'
import {
	Typography,
	Tabs, 
	Tab,
	Select,
	MenuItem,
	Switch,
	TextField,
	FormControlLabel,
	IconButton
} from "@material-ui/core";
import ChipInput from 'material-ui-chip-input';
import {
	KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Link, Redirect } from 'react-router-dom';
import { useSnackbar } from "notistack";
import { Formik, FieldArray } from "formik";
import { injectIntl } from "react-intl";
import SVG from "react-inlinesvg";
import DeleteIcon from '@material-ui/icons/Delete';

import { useSubheader } from '../../../../../_metronic/layout';
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers';

import { 
	get_owner_library_details, 
	get_owner_library_content, 
	get_owner_enrollees_list, 
	update_owner_library_settings, 
	publish_owner_library,
	sort_owner_module,
	sort_owner_lesson
} from '../../_redux/LibrariesCrud';
import { get_owner_teams } from '../../../../modules/Teams/pages/_redux/TeamsCrud';
import { get_owner_positions } from '../../../../modules/Positions/pages/_redux/PositionsCrud';
import { AddOwnerCompanyLibrary, CreateOwnerEnrollee, CreateOwnerModule, CreateOwnerModuleLesson, CreateOwnerLibraryLesson, EditOwnerModule, DeleteOwnerModule, DeleteOwnerLesson, EditOwnerLesson, AddLibraryMentor, AddOwnerTeamLibrary, AddOwnerPositionLibrary } from './components/LibraryDetailsModals';
import { CompaniesEnrolledList, MentorsList, OwnerEnrolleesList, TeamsEnrolledList, PositionsEnrolledList } from './components/LibraryDetailsTables';
import { Spinner } from 'react-bootstrap';

export const OwnerLibraryDetails = injectIntl(({ params, intl }) => {
	const [recentLibraryTab, setRecentLibraryTab] = useState("Details");
	const [library, setLibrary] = useState({});
	const [libraryContent, setLibraryContent] = useState([]);
	const [enrolleesList, setEnrolleesList] = useState([]);
	const [importEnrolleesList, setImportEnrolleesList] = useState([]);
	const [teams, setTeams] = useState([]);
	const [positions, setPositions] = useState([]);
	const [init, setInit] = useState(false);
	const [accessDenied, setAccessDenied] = useState(false);
	const [companiesEnrolled, setCompaniesEnrolled] = useState([]);
	const [teamsEnrolled, setTeamsEnrolled] = useState([]);
	const [positionsEnrolled, setPositionsEnrolled] = useState([]);
	const [mentorsList, setMentorsList] = useState([]);
	const [disableSort, setDisableSort] = useState(false);

	const { enqueueSnackbar } = useSnackbar();

	const snackbarAlert = (variant, message) => {
		// variant could be success, error, warning, info, or default
		enqueueSnackbar(message, { variant });
	};

	useEffect(() => {
		get_owner_library_details(params.library_party_id).then(({ data: { library_query } }) => {
			if(library_query) {
				setLibrary(library_query);
			}
		}).catch(err => {
			console.log(err);
			setAccessDenied(true);
		});

		get_owner_library_content(params.library_party_id).then(({ data: { library_content_query } }) => {
			if(library_content_query) {
				setLibraryContent(library_content_query);
			}
			setInit(true);
		}).catch(err => console.log(err))

		get_owner_enrollees_list(params.library_party_id).then(({ data: { enrollees_list_query, companies_enrolled_query, teams_enrolled_query, positions_enrolled_query, library_mentors_query } }) => {
			if(enrollees_list_query) {
				setEnrolleesList(enrollees_list_query);
				setCompaniesEnrolled(companies_enrolled_query);
				setTeamsEnrolled(teams_enrolled_query);
				setPositionsEnrolled(positions_enrolled_query);
				setMentorsList(library_mentors_query);
			}
		}).catch(err => console.log(err))

		get_owner_teams("", params.library_party_id).then(({ data: { teams } }) => {
			if(teams) {
				setTeams(teams)
			}
		}).catch(err => console.log(err));

		get_owner_positions("", params.library_party_id).then(({ data: { positions } }) => {
			if(positions) {
				setPositions(positions)
			}
		}).catch(err => console.log(err));
	}, [params.library_party_id]);
	
	const suhbeader = useSubheader();
	suhbeader.setTitle(library.title || "Library");

	if(accessDenied) {
		snackbarAlert("error", "Access Denied");
		return <Redirect to="/" />
	}

	if(!init || !library.title) {
		return <Spinner animation="grow" />
	}

	var isMobile = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);

	return <>
		<div className="row" style={{marginTop: "-40px"}}>
			<div className="col-12">
				<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
					<div className="card-body">
						<div className="d-flex justify-content-end">
							<Tabs
								className="mb-3"
								style={{display: "contents"}}
								value={recentLibraryTab}
								onChange={(e, newValue) => {
									setRecentLibraryTab(newValue);
								}}
								indicatorColor="secondary"
								textColor="secondary"
								variant="scrollable"
								// variant="fullWidth"
							>
								<Tab value="Overview" label="Overview" />
								<Tab value="Details" label="Details" />
								<Tab value="Users" label="Users" />
								<Tab value="Settings" label="Settings" />
							</Tabs>

							<div>
								<Link
									to={`/libraries/update-library/${params.library_party_id}`}
									className="btn btn-primary mr-3"
									style={{alignSelf: "center"}}
								>
									Edit
								</Link>
								{Boolean(library.isPublished) ? <button
									type="button"
									className="btn btn-danger"
									style={{alignSelf: "center"}}
									onClick={async () => {
										try {
											const { status, data: { library_query } } = await publish_owner_library(params.library_party_id, { publish: !library.isPublished });
											if(status === 200) {
												snackbarAlert("warning", "Library Unpublished");
												setLibrary(library_query);
											}
										} catch(err) {
											console.log(err);
											snackbarAlert("error", "Something went wrong");
										}
									}}
								>
									Unpublish
								</button> : <button
									type="button"
									className="btn btn-success"
									style={{alignSelf: "center"}}
									onClick={async () => {
										try {
											const { status, data: { library_query } } = await publish_owner_library(params.library_party_id, { publish: !library.isPublished });
											if(status === 200) {
												snackbarAlert("success", "Library published");
												setLibrary(library_query);
											}
										} catch(err) {
											console.log(err);
											snackbarAlert("error", "Something went wrong");
										}
									}}
								>
									Publish
								</button>}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		{(() => {
			switch(recentLibraryTab) {
				case "Overview": 
					return <div className="row">
						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Overview</h3>
								</div>
								<div className="card-body">
									<div className="row">
										<div className="col-lg-3 col-md-3">
											<img 
												src={library.image_file ? `${process.env.REACT_APP_S3_BUCKET}/library_uploads/images/${library.image_file}` : "https://lernnex.s3.amazonaws.com/library_uploads/images/default_library_image.jpg"}
												alt={library.title}
												className="w-100 rounded"
											/>
										</div>
										<div className="col-lg-9 col-md-3">
											{
												Boolean(library.description) && (
													<div>
														<Typography variant="h6">
															Description: 
														</Typography>

														<Typography variant="body1" style={{whiteSpace : "pre-line"}}>
															{library.description}
														</Typography>
														<br />
													</div>
												)
											}

											{
												Boolean(library.context && library.context.what_will_you_learn) && (
													<div>
														<Typography variant="h6">
															What will you learn?: 
														</Typography>

														<Typography variant="body1" style={{whiteSpace : "pre-line"}}>
															{library.context.what_will_you_learn}
														</Typography>
														<br />
													</div>
												)
											}

											{
												Boolean(library.context && library.context.who_should_take_this) && (
													<div>
														<Typography variant="h6">
															Who should take this?: 
														</Typography>

														<Typography variant="body1" style={{whiteSpace : "pre-line"}}>
															{library.context.who_should_take_this}
														</Typography>
														<br />
													</div>
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				case "Details": 
					return <div className="row">
						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Modules and Lessons</h3>
									<div className="card-toolbar">
										{library.settings.group_content ? 
											<CreateOwnerModule 
												library={library} 
												libraryContent={libraryContent} 
												setLibraryContent={setLibraryContent} 
											/> : <CreateOwnerLibraryLesson 
												headerButton={true}
												library={library} 
												libraryContent={libraryContent} 
												setLibraryContent={setLibraryContent} 
											/>}
										
									</div>
								</div>

								<div className="card-body">
									
									{(() => {

										if(!libraryContent.length) {
											return <div className="d-flex ml-5 mb-2 border-bottom">
												No content yet...
											</div>
										}
										
										return libraryContent.sort((a,b) => (a.sort-b.sort)).map((indiv_module, module_index) => {
											if(library.settings.group_content) {
												return (
													<div key={module_index} className="form-group">
														<div className="p-3 bg-secondary d-flex rounded mb-2 align-items-center">
															<Typography className="font-weight-bolder">
																{indiv_module.title}
															</Typography>
															

															{ indiv_module.resource_id !== "library_lesson" && <>

																<button 
																	disabled={disableSort || !module_index}
																	type="button"
																	style={{ transform: "rotate(180deg)" }}
																	className={`ml-auto btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || !module_index ? "muted" : "primary"}`}
																	onClick={async () => {
																		setDisableSort(true);
																		await sort_owner_module(indiv_module.resource_id, { 
																			library_party_id: library.party_id,
																			module_index: module_index,
																			sort: module_index - 1
																		}).then(({ data: { library_content_query } }) => {
																			if(library_content_query) {
																				setLibraryContent(library_content_query);
																				snackbarAlert("success", "Module Moved Up");
																			}
																			setDisableSort(false);
																		}).catch(err => {
																			console.log(err)
																			setDisableSort(false);
																			snackbarAlert("error", "Something went wrong!");
																		});
																	}}
																>
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																	/>
																</button>

																<button 
																	disabled={libraryContent.length - 1 === module_index}
																	type="button"
																	className={`ml-3 btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || libraryContent.length - 1 === module_index ? "muted" : "primary"}`}
																	onClick={async () => {
																		setDisableSort(true);
																		await sort_owner_module(indiv_module.resource_id, { 
																			library_party_id: library.party_id,
																			module_index: module_index,
																			sort: module_index + 1
																		}).then(({ data: { library_content_query } }) => {
																			if(library_content_query) {
																				setLibraryContent(library_content_query);
																				snackbarAlert("success", "Module Moved Down");
																			}
																			setDisableSort(false);
																		}).catch(err => {
																			console.log(err)
																			setDisableSort(false);
																			snackbarAlert("error", "Something went wrong!");
																		});
																	}}
																>
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																	/>
																</button>

																<span className="mx-3 text-muted"> | </span>

																<EditOwnerModule 
																	library={library} 
																	module={indiv_module}
																	moduleIndex={module_index} 
																	libraryContent={libraryContent} 
																	setLibraryContent={setLibraryContent} 
																/>
																
																<span className="mx-3 text-muted"> | </span>

																<DeleteOwnerModule 
																	library={library} 
																	module={indiv_module}
																	moduleIndex={module_index} 
																	libraryContent={libraryContent} 
																	setLibraryContent={setLibraryContent} 
																/>

																<span className="mx-3 text-muted"> | </span>
															</> }

															<CreateOwnerModuleLesson 
																library={library} 
																module={indiv_module}
																moduleIndex={module_index} 
																libraryContent={libraryContent} 
																setLibraryContent={setLibraryContent} 
															/>
														</div>
														{indiv_module.lessons && indiv_module.lessons.length ? indiv_module.lessons.map((indiv_lesson, lesson_index) => {
															return (
																<div key={lesson_index} className="d-flex ml-5 mb-2 border-bottom">
																	<Link 
																		to={`/libraries/${params.library_type}/${params.library_party_id}/module/${indiv_module.resource_id}/lesson/${indiv_lesson.resource_id}`} 
																		className="text-primary"
																		style={{fontSize: "medium"}}
																	>
																		{indiv_lesson.title}
																	</Link>

																	<button 
																		disabled={disableSort || !lesson_index}
																		type="button"
																		style={{ transform: "rotate(180deg)" }}
																		className={`ml-auto btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || !lesson_index ? "muted" : "primary"}`}
																		onClick={async () => {
																			setDisableSort(true);
																			await sort_owner_lesson(indiv_lesson.resource_id, { 
																				library_party_id: library.party_id,
																				lesson_index: lesson_index,
																				module_resource_id: indiv_module.resource_id,
																				sort: lesson_index - 1
																			}).then(({ data: { module_query } }) => {
																				if(module_query) {
																					let newLibraryContent = [...libraryContent];
																					newLibraryContent.splice(module_index, 1, module_query)
																					setLibraryContent(newLibraryContent);
																					snackbarAlert("success", "Lesson Moved Up");
																				}
																				setDisableSort(false);
																			}).catch(err => {
																				console.log(err)
																				setDisableSort(false);
																				snackbarAlert("error", "Something went wrong!");
																			});
																		}}
																	>
																		<SVG
																			src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																		/>
																	</button>

																	<button 
																		disabled={disableSort || indiv_module.lessons.length - 1 === lesson_index}
																		type="button"
																		className={`ml-3 btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || indiv_module.lessons.length - 1 === lesson_index ? "muted" : "primary"}`}
																		onClick={async () => {
																			setDisableSort(true);
																			await sort_owner_lesson(indiv_lesson.resource_id, { 
																				library_party_id: library.party_id,
																				lesson_index: lesson_index,
																				module_resource_id: indiv_module.resource_id,
																				sort: lesson_index + 1
																			}).then(({ data: { module_query } }) => {
																				if(module_query) {
																					let newLibraryContent = [...libraryContent];
																					newLibraryContent.splice(module_index, 1, module_query)
																					setLibraryContent(newLibraryContent);
																					snackbarAlert("success", "Lesson Moved Up");
																				}
																				setDisableSort(false);
																			}).catch(err => {
																				console.log(err)
																				setDisableSort(false);
																				snackbarAlert("error", "Something went wrong!");
																			});
																		}}
																	>
																		<SVG
																			src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																		/>
																	</button>

																	<span className="mx-3 text-muted"> | </span>
																	
																	<EditOwnerLesson
																		library={library} 
																		module={indiv_module}
																		moduleIndex={module_index} 
																		libraryContent={libraryContent}
																		setLibraryContent={setLibraryContent}
																		lesson={indiv_lesson}
																		lessonIndex={lesson_index}
																	/>
																	

																	<span className="mx-3 text-muted"> | </span>

																	<DeleteOwnerLesson
																		library={library} 
																		module={indiv_module}
																		moduleIndex={module_index} 
																		libraryContent={libraryContent} 
																		setLibraryContent={setLibraryContent}
																		lesson={indiv_lesson}
																		lessonIndex={lesson_index}
																	/>

																	<span className="mx-3 text-muted"> | </span>
																	
																	{!isMobile && (
																		<Link 
																		to={`/libraries/${params.library_type}/${params.library_party_id}/module/${indiv_module.resource_id}/lesson/${indiv_lesson.resource_id}`} 
																		className="text-primary mr-3"
																	>
																		View
																	</Link>
																	)}
																	
																</div>
															);
														}) : (
															<div className="text-center">
																Please add a topic...
															</div>
														)}
													</div>
												)
											} else {
												return <div key={module_index}>
													{indiv_module.lessons && indiv_module.lessons.length ? indiv_module.lessons.map((indiv_lesson, lesson_index) => {
														return (
															<div key={lesson_index} className="d-flex ml-5 mb-2 border-bottom">
																<Link 
																	to={`/libraries/${params.library_type}/${params.library_party_id}/module/${indiv_module.resource_id}/lesson/${indiv_lesson.resource_id}`} 
																	className="text-primary"
																	style={{fontSize: "medium"}}
																>
																	{indiv_lesson.title}
																</Link>

																<button 
																	disabled={disableSort || !lesson_index}
																	type="button"
																	style={{ transform: "rotate(180deg)" }}
																	className={`ml-auto btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || !lesson_index ? "muted" : "primary"}`}
																	onClick={async () => {
																		setDisableSort(true);
																		await sort_owner_lesson(indiv_lesson.resource_id, { 
																			library_party_id: library.party_id,
																			lesson_index: lesson_index,
																			module_resource_id: indiv_module.resource_id,
																			sort: lesson_index - 1
																		}).then(({ data: { module_query } }) => {
																			if(module_query) {
																				let newLibraryContent = [...libraryContent];
																				newLibraryContent.splice(module_index, 1, module_query)
																				setLibraryContent(newLibraryContent);
																				snackbarAlert("success", "Lesson Moved Up");
																			}
																			setDisableSort(false);
																		}).catch(err => {
																			console.log(err)
																			setDisableSort(false);
																			snackbarAlert("error", "Something went wrong!");
																		});
																	}}
																>
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																	/>
																</button>

																<button 
																	disabled={disableSort || indiv_module.lessons.length - 1 === lesson_index}
																	type="button"
																	className={`ml-3 btn p-0 svg-icon svg-icon-xl svg-icon-${disableSort || indiv_module.lessons.length - 1 === lesson_index ? "muted" : "primary"}`}
																	onClick={async () => {
																		setDisableSort(true);
																		await sort_owner_lesson(indiv_lesson.resource_id, { 
																			library_party_id: library.party_id,
																			lesson_index: lesson_index,
																			module_resource_id: indiv_module.resource_id,
																			sort: lesson_index + 1
																		}).then(({ data: { module_query } }) => {
																			if(module_query) {
																				let newLibraryContent = [...libraryContent];
																				newLibraryContent.splice(module_index, 1, module_query)
																				setLibraryContent(newLibraryContent);
																				snackbarAlert("success", "Lesson Moved Up");
																			}
																			setDisableSort(false);
																		}).catch(err => {
																			console.log(err)
																			setDisableSort(false);
																			snackbarAlert("error", "Something went wrong!");
																		});
																	}}
																>
																	<SVG
																		src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-down.svg")}
																	/>
																</button>
																
																<span className="mx-3 text-muted"> | </span>

																<EditOwnerLesson
																	library={library} 
																	module={indiv_module}
																	moduleIndex={module_index} 
																	libraryContent={libraryContent} 
																	setLibraryContent={setLibraryContent}
																	lesson={indiv_lesson}
																	lessonIndex={lesson_index}
																/>
																
																<span className="mx-3 text-muted"> | </span>

																<DeleteOwnerLesson
																	library={library} 
																	module={indiv_module}
																	moduleIndex={module_index} 
																	libraryContent={libraryContent} 
																	setLibraryContent={setLibraryContent}
																	lesson={indiv_lesson}
																	lessonIndex={lesson_index}
																/>

																<span className="mx-3 text-muted"> | </span>

																<Link 
																	to={`/libraries/${params.library_type}/${params.library_party_id}/module/${indiv_module.resource_id}/lesson/${indiv_lesson.resource_id}`} 
																	className="text-primary mr-3"
																>
																	View
																</Link>
															</div>
														);
													}) : (
														<div className="text-center">
															Please add a topic...
														</div>
													)}
												</div>
											}
										})
									})()}
								</div>
							</div>
						</div>
					</div>
				case "Users": 
					return <div className="row">
						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Enrollees</h3>
									<div className="card-toolbar">
										<CreateOwnerEnrollee library={library} enrolleesList={enrolleesList} setEnrolleesList={setEnrolleesList} importEnrolleesList={importEnrolleesList} setImportEnrolleesList={setImportEnrolleesList} />
									</div>
								</div>
								<div className="card-body">
									<OwnerEnrolleesList enrolleesList={enrolleesList} setEnrolleesList={setEnrolleesList} library={library} />
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Companies Enrolled ({companiesEnrolled.length})</h3>
									<div className="card-toolbar">
										<AddOwnerCompanyLibrary companiesEnrolled={companiesEnrolled} setCompaniesEnrolled={setCompaniesEnrolled} library={library} />
									</div>
								</div>
								<div className="card-body">
									<CompaniesEnrolledList companiesEnrolled={companiesEnrolled} enrolleesList={enrolleesList} />
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Teams Enrolled ({teamsEnrolled.length})</h3>
									<div className="card-toolbar">
										<AddOwnerTeamLibrary teams={teams} teamsEnrolled={teamsEnrolled} setTeamsEnrolled={setTeamsEnrolled} library={library} />
									</div>
								</div>
								<div className="card-body">
									<TeamsEnrolledList teamsEnrolled={teamsEnrolled} enrolleesList={enrolleesList} />
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Positions Enrolled ({positionsEnrolled.length})</h3>
									<div className="card-toolbar">
										<AddOwnerPositionLibrary positions={positions} positionsEnrolled={positionsEnrolled} setPositionsEnrolled={setPositionsEnrolled} library={library} />
									</div>
								</div>
								<div className="card-body">
									<PositionsEnrolledList positionsEnrolled={positionsEnrolled} enrolleesList={enrolleesList} />
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-header">
									<h3 className="card-title font-weight-bolder">Mentors</h3>
									<div className="card-toolbar">
										<AddLibraryMentor library={library} mentorsList={mentorsList} setMentorsList={setMentorsList} />
									</div>
								</div>
								<div className="card-body">
									<MentorsList mentorsList={mentorsList} setMentorsList={setMentorsList} library={library} />
								</div>
							</div>
						</div>
					</div>
				case "Settings": 
					return <div className="row">
						<div className="col-12">
							<div className={`card card-custom bg-gray-100 card-stretch gutter-b`}>
								<div className="card-body">
									<Formik
										enableReinitialize={true}
										initialValues={{
											availability_date: new Date((library.settings.availability_date) ?? new Date()),
											access_type: (library.settings.access_type) ?? "By Approval",
											course_deadline: (library.settings.course_deadline) ?? 30,
											expire_access: Boolean(library.settings.expire_access.isExpiring),
											expire_access_deadline: (library.settings.expire_access.expire_access_deadline) ?? 0,
											hide_outline: Boolean(library.settings.hide_outline),
											allow_questions: Boolean(library.settings.allow_questions.isAllowed),
											email_question_to: (library.settings.allow_questions.email_question_to) ?? [{first_name:"",last_name:"",email:""}],
											publish_in_olern_cost: (library.settings.publish_in_olern.publish_in_olern_cost) ?? "",
											publish_in_olern_discount: (library.settings.publish_in_olern.publish_in_olern_discount) ?? "",
											course_author_fullname: (library.settings.course_author.fullname) ?? "",
											course_author_email: (library.settings.course_author.email) ?? [],
											payment_link: (library.settings.payment_link) ?? "",
											group_content: (library.settings.group_content) ?? true,
										}}
										validate={values => {
											const errors = {};

											if (!values.availability_date) {
												errors.availability_date = intl.formatMessage({
													id: "AUTH.VALIDATION.REQUIRED_FIELD"
												});
											}

											if (!values.access_type) {
												errors.access_type = intl.formatMessage({
													id: "AUTH.VALIDATION.REQUIRED_FIELD"
												});
											}

											if(values.allow_questions) {
												errors.email_question_to = []
			
												if(values.email_question_to.length > 0) {
													values.email_question_to.forEach(question_to => {
														const error = {};
										
														if (!question_to.first_name) {
															error.first_name = intl.formatMessage({
																id: "AUTH.VALIDATION.REQUIRED_FIELD"
															});
														}

														if (!question_to.last_name) {
															error.last_name = intl.formatMessage({
																id: "AUTH.VALIDATION.REQUIRED_FIELD"
															});
														}

														if (!question_to.email) {
															error.email = intl.formatMessage({
																id: "AUTH.VALIDATION.REQUIRED_FIELD"
															});
														}

														errors.email_question_to.push(error);
													});
												}

												let stop = false;
												errors.email_question_to.map((error, index) => {
													if(!stop) {
														if(Object.keys(error).length) {
															stop = true;
														}
														else if(index+1 === errors.email_question_to.length) {
															delete errors.email_question_to
														}
													}
												})
											}

											//Course deadline min & max
											if(values.course_deadline > 999) {
												values.course_deadline = 999;
											} else if(values.course_deadline < 1) {
												values.course_deadline = 1;
											}

											if(values.course_deadline.toString().match(/[a-z]/i)) {
												values.course_deadline = 30;
											}

											if(values.publish_in_olern_cost.toString().match(/[a-z]/i)) {
												values.publish_in_olern_cost = "";
											}

											if(values.publish_in_olern_discount.toString().match(/[a-z]/i)) {
												values.publish_in_olern_discount = "";
											}

											//if access expires
											if(values.expire_access && values.expire_access_deadline === "") {
												values.expire_access_deadline = 30;
											} 

											if(!values.expire_access) {
												values.expire_access_deadline = "";
											}

											//access deadline min & max
											if(values.expire_access_deadline > 999) {
												values.expire_access_deadline = 999;
											} else if(values.expire_access_deadline < 1 && values.expire_access) {
												values.expire_access_deadline = 1;
											}

											return errors;
										}}
										onSubmit={async (values, { setSubmitting, resetForm }) => {
											let post_values = {
												"availability_date": values.availability_date.toISOString(),
												"access_type": values.access_type,
												"course_deadline": values.course_deadline,
												"expire_access": {
													"isExpiring": values.expire_access,
													"expire_access_deadline": values.expire_access_deadline
												},
												"hide_outline": values.hide_outline,
												"allow_questions": {
													"isAllowed": values.allow_questions,
													"email_question_to": values.email_question_to
												},
												"publish_in_olern": {
													"publish_in_olern_cost": values.publish_in_olern_cost,
													"publish_in_olern_discount": values.publish_in_olern_discount
												},
												"course_author": {
													"fullname": values.course_author_fullname,
													"email": values.course_author_email
												},
												"payment_link": values.payment_link,
												"group_content": values.group_content,
											};
											
											try {
												const { status, data: { library_query } } = await update_owner_library_settings(params.library_party_id, post_values);
												
												if(status === 200) {
													snackbarAlert("success", "Settings updated");
													setLibrary(library_query);
												}
											} catch(err) {
												console.log(err);
												snackbarAlert("error", "Something went wrong");
											}
										}}
									>
										{({
											values,
											status,
											errors,
											touched,
											handleChange,
											handleBlur,
											handleSubmit,
											isSubmitting,
											setFieldValue,
											handleReset
										}) => (
											<form
												onSubmit={handleSubmit}
												noValidate
												autoComplete="off"
												className="w-100"
											>
												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Availability Date:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<div className="d-flex align-items-center h-100">
																<KeyboardDatePicker
																	color="secondary"
																	disableToolbar
																	variant="inline"
																	autoOk={true}
																	disablePast={true}
																	name={"availability_date"}
																	value={values.availability_date}
																	format="dd/MM/yyyy"
																	helperText={touched.availability_date && errors.availability_date}
																	error={Boolean(touched.availability_date && errors.availability_date)}
																	onChange={date => setFieldValue("availability_date", date)}
																/>
																<Typography>
																	&nbsp; {Boolean(values.availability_date) && values.availability_date.toLocaleDateString(undefined, { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })}
																</Typography>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Access Type:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<Select
																name="access_type"
																value={values.access_type}
																onChange={handleChange}
																onBlur={handleBlur}
																error={Boolean(
																	touched.access_type && errors.access_type
																)}
																style={{minWidth: 205}}
																color="secondary"
															>
																<MenuItem
																	disabled={true}
																	className="bg-light"
																	value={""}
																>
																	Select Access Type
																</MenuItem>

																<MenuItem className="bg-light" value={"Open"}>
																	Open
																</MenuItem>

																<MenuItem className="bg-light" value={"By Approval"}>
																	By Approval
																</MenuItem>

																<MenuItem className="bg-light" value={"Private"}>
																	Private
																</MenuItem>
															</Select>
															<small className="text-danger">
																{touched.access_type && errors.access_type}
															</small>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex align-items-center h-100">
																<Typography variant="body1">
																	Course Deadline:
																</Typography>
															</div>
														</div>
														<div className="col-9">
															<div className="d-flex align-items-center h-100">
																<div style={{ maxWidth: 50 }}>
																	<TextField
																		inputProps={{
																			style: {
																				textAlign: "center"
																			},
																		}}
																		className="w-100 text-center"
																		name="course_deadline"
																		margin="dense"
																		onBlur={handleBlur}
																		onChange={handleChange}
																		value={values.course_deadline}
																		color="secondary"
																	/>
																</div>
																<Typography>
																	&nbsp; Day/s after enrollment
																</Typography>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Expire Access:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<div className="d-flex">
																<FormControlLabel
																	control={
																		<Switch
																			onChange={handleChange}
																			checked={Boolean(values.expire_access)}
																			value={values.expire_access}
																			inputProps={{
																				"aria-label": "expire_access",
																				name: "expire_access"
																			}}
																		/>
																	}
																	label={values.expire_access ? "Yes" : ""}
																/>
																<div style={{ maxWidth: 50 }}>
																	<TextField
																		disabled={!values.expire_access}
																		inputProps={{
																			style: {
																				textAlign: "center"
																			},
																		}}
																		color="secondary"
																		className="w-100 text-center"
																		name="expire_access_deadline"
																		margin="dense"
																		onBlur={handleBlur}
																		onChange={handleChange}
																		value={values.expire_access_deadline}
																	/>
																</div>
																<div className="align-self-center">
																	&nbsp; Day/s after enrollment
																</div>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Hide Outline To Non-Users:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<FormControlLabel
																control={
																	<Switch
																		onChange={handleChange}
																		checked={Boolean(values.hide_outline)}
																		value={values.hide_outline}
																		name="hide_outline"
																	/>
																}
																label={values.hide_outline && "Yes"}
															/>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Allow Questions:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<FormControlLabel
																		control={
																			<Switch
																				onChange={handleChange}
																				checked={Boolean(values.allow_questions)}
																				value={values.allow_questions}
																				name="allow_questions"
																			/>
																		}
																		label={values.allow_questions && "Yes"}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
												{
													values.allow_questions && <>
														<FieldArray
															name="email_question_to"
															render={additionals => (<div>
																{
																	values.email_question_to.map((indiv_to, to_index) => {
																		return <div class="row">
																			<div style={{display: "inline-flex"}} className="w-100">
																				<div className="col-2"></div>
																				<div className="col-3">
																					<TextField
																						className="w-100"
																						color="secondary"
																						name={`email_question_to[${to_index}].first_name`}
																						onBlur={handleBlur}
																						placeholder="First Name"
																						onChange={handleChange}
																						value={values.email_question_to[to_index].first_name}
																						error={Boolean(touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].first_name && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].first_name)}
																						helperText={touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].first_name && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].first_name}
																					/>
																				</div>
																				<div className="col-3">
																					<TextField
																						className="w-100"
																						color="secondary"
																						name={`email_question_to[${to_index}].last_name`}
																						onBlur={handleBlur}
																						placeholder="Last Name"
																						onChange={handleChange}
																						value={values.email_question_to[to_index].last_name}
																						error={Boolean(touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].last_name && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].last_name)}
																						helperText={touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].last_name && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].last_name}
																					/>
																				</div>
																				<div className="col-3">
																					<TextField
																						className="w-100"
																						color="secondary"
																						name={`email_question_to[${to_index}].email`}
																						onBlur={handleBlur}
																						placeholder="Email"
																						onChange={handleChange}
																						value={values.email_question_to[to_index].email}
																						error={Boolean(touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].email && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].email)}
																						helperText={touched.email_question_to && touched.email_question_to[to_index] && touched.email_question_to[to_index].email && errors.email_question_to && errors.email_question_to[to_index] && errors.email_question_to[to_index].email}
																					/>
																				</div>
																				<div className="col-1">
																					{(to_index != 0) &&
																						<IconButton
																							onClick={() => additionals.remove(to_index)}
																						>
																							<DeleteIcon style={{color: "red"}}/>
																						</IconButton>
																					}
																				</div>
																			</div>
																		</div>
																	})
																}
																<div className="form-group">
																	<div className="row">
																		<div className="col-9"></div>
																		<div className="col-2" style={{textAlign: "end"}}>
																			<button
																				type="button"
																				className="btn text-success" 
																				style={{paddingRight: "0px", paddingTop: "20px"}}
																				onClick={() => additionals.push({first_name:"",last_name:"",email:""})}
																			>
																				Add more emails
																			</button>
																		</div>
																	</div>
																</div>
															</div>)}
														/>
													</>
												}
												</div>
												

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex align-items-center h-100">
																<Typography variant="body1">
																	Course Price:
																</Typography>
															</div>
														</div>
														<div className="col-3">
															<div className="d-flex h-100 align-items-center">
																<Typography><span>Php. </span></Typography>
																<TextField
																	color="secondary"
																	inputProps={{
																		style: {
																			textAlign: "center",
																			maxWidth: 100,
																		},
																	}}
																	className="text-center"
																	name="publish_in_olern_cost"
																	margin="dense"
																	onBlur={handleBlur}
																	onChange={handleChange}
																	value={values.publish_in_olern_cost}
																/>
																<Typography>&nbsp; per user</Typography>
															</div>
														</div>
														<div className="col-5">
															<div className="d-flex h-100 align-items-center">
																<Typography className="mx-3">
																	Discounted Price:
																</Typography>
																<Typography>Php. </Typography>
																<TextField
																	color="secondary"
																	inputProps={{
																		style: {
																			textAlign: "center",
																			maxWidth: 100,
																		},
																	}}
																	className="text-center"
																	name="publish_in_olern_discount"
																	margin="dense"
																	onBlur={handleBlur}
																	onChange={handleChange}
																	value={values.publish_in_olern_discount}
																/>
																<div className="align-self-center">
																	&nbsp; per user
																</div>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Course Author:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<div className="border rounded p-2 h-100">
																<div className="form-group">
																	<TextField
																		color="secondary"
																		label="Author Full Name:"
																		placeholder="Input course author full name"
																		InputLabelProps={{
																			shrink: true,
																		}}
																		className="w-50 mr-3"
																		name="course_author_fullname"
																		onBlur={handleBlur}
																		onChange={handleChange}
																		value={values.course_author_fullname}
																	/>
																</div>
														
																<ChipInput
																	className="w-100 mr-3"
																	InputProps={{ name: "course_author_email", placeholder: "Input email and press enter" }}
																	value={values.course_author_email}
																	onAdd={(chip) => {
																		values.course_author_email.push(chip);
																		setFieldValue("course_author_email", values.course_author_email);
																	}}
																	onDelete={(chip, index) => {
																		values.course_author_email.splice(index, 1);
																		setFieldValue("course_author_email", values.course_author_email);
																	}}
																	label="Author Email"
																	InputLabelProps={{
																		shrink: true,
																	}}
																/>
															</div>
														</div>
													</div>
												</div>

												<div className="form-group">
													<div className="row">
														<div className="col-3">
															<div className="d-flex h-100">
																<div className="align-self-center">
																	<Typography variant="body1">
																		Payment Link:
																	</Typography>
																</div>
															</div>
														</div>
														<div className="col-9">
															<TextField
																color="secondary"
																label="Payment Link"
																placeholder="Input payment link"
																InputLabelProps={{
																	shrink: true,
																}}
																className="w-100 m-0"
																name="payment_link"
																margin="dense"
																onBlur={handleBlur}
																onChange={handleChange}
																value={values.payment_link}
															/>
														</div>
													</div>
												</div>

												<div className="text-right">
													<Link to={`/libraries`}>
														<button
															type="button"
															variant="contained"
															className="btn btn-secondary btn-elevate kt-login__btn-secondary ml-auto mr-2"
														>
															Back to List
														</button>
													</Link>
													<button
														type="submit"
														disabled={isSubmitting}
														className="btn btn-success btn-elevate kt-login__btn-primary"
													>
														Save
													</button>
												</div>
											</form>
										)}
									</Formik>
								</div>
							</div>      
						</div>
					</div>
				
				default: 
					return setRecentLibraryTab("Details");
			}
		})()}
	</>
})
